import Link from "next/link";
import React from "react";
import styles from "./breadcrumb.module.scss";

const Breadcrumb = ({ universityProfileData }) => {
  return (
    <div className={styles.breadcrumbs}>
      <div className={styles.link_area}>
        <Link href="/" className={styles.link}>
          Home ›
        </Link>
        <Link
          href={`/${universityProfileData?.countrySlug}/university`}
          className={styles.link}
        >
          Universities in {universityProfileData?.CountryName} ›
        </Link>
        <Link
          className={styles.link}
          href={`/study/${universityProfileData?.countrySlug}/university/${universityProfileData?.universitySlug}`}
        >
          {universityProfileData?.universityName} ›
        </Link>
        <div className={styles.link}>Courses</div>
      </div>
    </div>
  );
};

export default Breadcrumb;
